






























import AgencySelect from '@/modules/agency/components/AgencySelect.vue';
import { tagApi } from '../tag.api';
import { Prop, Component, Watch } from 'vue-property-decorator';
import { debounce } from '@/modules/core/decorators/debounce';
import { PermissionType } from '@shared/common/types';
import AuthenticationService from '@/auth.service';
import { TagFormModel } from '../tag.form-model';
import { plainToClass } from 'class-transformer';
import EditFormClass from '@/modules/core/components/EditForm';
import EditForm from '@/modules/core/components/EditForm.vue';

@Component({
  components: {
    EditForm,
    AgencySelect,
  },
})
export default class TagEdit extends EditFormClass {
  public isLabelAvailable = true;
  public originalLabel?: string;
  public PermissionType = PermissionType;
  public entityCreatedMsg = 'Tag créé';
  public entityUpdatedMsg = 'Tag mis à jour';
  public formModelClass = TagFormModel;
  public api = tagApi;

  @Prop()
  public tagId: any;

  @Prop()
  public tag: any;

  @Prop({
    default: true,
  })
  public allowSave!: boolean;

  @Prop()
  public showInvalidMsg!: boolean;

  public formModel = new TagFormModel();

  public get entityId(): string {
    return this.tagId;
  }

  public get cardTitle(): string {
    return this.creation
      ? 'Nouveau tag'
      : `Edition du tag ${this.formModel.label}`;
  }

  public get creation(): boolean {
    return (!this.tag && !this.tagId) || (this.tag && !this.tag.id);
  }

  public get saveLabel(): string {
    return this.creation ? 'Créer' : 'Enregistrer';
  }

  public async cancel(): Promise<void> {
    this.$emit('cancel');
  }

  @debounce(300)
  public async onLabelChange(): Promise<void> {
    return this.checkLabelAvailability();
  }

  public async onAgencyChange(): Promise<void> {
    return this.checkLabelAvailability();
  }

  public async checkLabelAvailability(): Promise<void> {
    this.formModel.validateField('label');
  }

  public mounted(): void {
    if (AuthenticationService.user && AuthenticationService.user.agencyId) {
      this.formModel.agencyId = AuthenticationService.user.agencyId;
    }
  }

  @Watch('tagId', { immediate: true })
  public async onTagIdChange(newVal: string): Promise<void> {
    if (newVal) {
      this.getEntity();
    } else {
      this.fetchedEntity = null;
    }
  }

  @Watch('formModel', { immediate: true })
  public onTagChange(): void {
    this.originalLabel = this.formModel.label;
  }

  @Watch('tag', { immediate: true })
  public onTagPropChange(): void {
    if (this.tag) {
      if (this.tag instanceof TagFormModel) {
        this.formModel = this.tag;
      } else {
        this.formModel = plainToClass(TagFormModel, this.tag);
        this.formModel.original = this.tag;
      }
    }
  }
}
